const SCRAPING_ENGINES = {
  MULTI_FORMAT: 'MULTI_FORMAT',
  PDF_AI: 'PDF_AI',
}

export default SCRAPING_ENGINES
